"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Select["default"];
  }
});

var _Select = _interopRequireDefault(require("./Select"));


//////////////////
// WEBPACK FOOTER
// ../~/semantic-ui-react/dist/commonjs/addons/Select/index.js
// module id = 2168
// module chunks = 1